import { render, staticRenderFns } from "./ft-modal.vue?vue&type=template&id=bb022eda&"
import script from "./ft-modal.vue?vue&type=script&lang=js&"
export * from "./ft-modal.vue?vue&type=script&lang=js&"
import style0 from "./ft-modal.vue?vue&type=style&index=0&id=bb022eda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports